<template lang="html">
  <section class="pack_configurator">
    <!--filters-->
    <b-collapse id="pack_filters" visible>
      <b-card
        header="Filters"
        header-bg-variant="primary"
        header-text-variant="light"
        id="filters"
      >
        <b-card-text>
            <b-row>
              <b-col class="col-lg-1 pt-2">Market:</b-col>          
              <b-select class="col-lg-5" v-model="selectedCountry" id="selectedCountry">
                <option v-if="getCurUser" v-for="(country,index) in getCurUser.countries" :key="country.id || index" :value="country">{{country.description}}</option>        
              </b-select>

              <b-col class="col-lg-1 pt-2">Model:</b-col>
              <b-select class="col-lg-5" v-model="selectedModel" id="selectedModel">
                <template v-if="selectedCountry != null && selectedCountry.modelGroupItemList">
                  <optgroup v-for="(models, gIndex) in ((selectedCountry && selectedCountry.modelGroupItemList) ? selectedCountry.modelGroupItemList : [])" :key="(models.label || 'grp') + '_' + gIndex" :label="models.label">
                    <option v-for="(model, index) in (models.items || [])" :key="String(model.value) + '_' + String(model.value2) + '_' + index" :value="model" >{{ model.label }}</option>
                  </optgroup>
                </template>
              </b-select>
            </b-row>
            <br/>
            <b-row>
              <b-col class="col-lg-1 pt-2">Preview Data:</b-col>
              <b-col class="col-lg-1"><input type="checkbox" v-model="previewData"/></b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="col-lg-12">
                <span class="float-right">
                  <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export packs</b-button>
                  <b-button variant="primary mr-1" v-b-modal.modal-import><i class="mdi mdi-file-import"></i>Import packs</b-button>
                </span>
              </b-col>
            </b-row>
        </b-card-text>
      </b-card>
    </b-collapse>
    <!--commercial packs-->
    <b-card class="mt-4">
      <b-card-text>
        <b-row class="mt-3">
          <h4 class="card-title col-lg-12">Pack Composition</h4>
          <p class="card-description ml-2" v-if="selectedCountry && selectedModel">
            {{selectedCountry.description}} - {{selectedModel.label}}
          </p>
          <b-col class="col-lg">
            <span class="float-right">
              <b-button variant="primary mr-1" v-b-toggle.pack_filters><i class="mdi mdi-filter"></i></b-button>
              <b-button variant="primary mr-1" @click="getModelBasePackInfo(true)"><i class="mdi mdi-refresh"></i>Refresh</b-button>
            </span>
          </b-col>
        </b-row>
        <b-table
          id="packsTable" 
          striped 
          border
          hover 
          responsive
          sticky-header="500px"
          small
          :items="packList" 
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="_id"
          no-local-sorting
          no-provider-paging
          sort-icon-left
          class="mt-4"
        >
          <!-- Custom row above header -->
          <template v-slot:thead-top="data" lang="html">
            <b-tr>
              <b-th variant="secondary" :colspan="fields.length">List of Packs for model: {{selectedModel ? selectedModel.label.split(" ")[0] : ''}} / Market: {{selectedCountry ? selectedCountry.description : ''}}</b-th>
            </b-tr>
          </template>
          <!-- A custom formatted column -->
          <template v-slot:cell(parentCode)="data" lang="html">
            <span v-if="!data.item.isChild">{{data.item.ocparObj.parele}} - {{data.item.ocparObj.parde2}}</span>
          </template>
          <template v-slot:cell(childCode)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.ocparObj.parele}} - {{data.item.ocparObj.parde2}}</span>
          </template>
          <template v-slot:cell(inclExcl)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.priceIncluded}}</span>
          </template>
          <template v-slot:cell(optManovra)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.optManovra}}</span>
          </template>
          <template v-slot:cell(set)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.alternateSet}}</span>
          </template>
          <template v-slot:cell(default)="data" lang="html">
            <span v-if="data.item.isChild">{{data.item.defaultSet}}</span>
          </template>
          <template v-slot:cell(implicitPacksContent)="data" lang="html">
            <b-button v-b-modal.implicitPacksContentModal @click="curItem = data.item" v-if="data.item.implicitList && data.item.implicitList.length" variant="secondary"><i class="mdi mdi-magnify"></i></b-button>
          </template>
          <template v-slot:cell(plus)="data" lang="html">
            <b-button v-if="data.item.ocparObj && !data.item.isChild" variant="secondary" @click="openCloseRow(data.item.ocparObj)">
              <i :class="'mdi mdi-'+(showChildren.includes(data.item.ocparObj)?'minus':'plus')"></i>
            </b-button>
          </template>
        </b-table>
         <b-modal v-if='curItem != null' id="implicitPacksContentModal" :title="curItem.ocparObj.parele + ' - ' + curItem.ocparObj.parde2" header-bg-variant="primary" header-text-variant="light" centered>
          <b-container fluid>
            <b>Implicit Content:</b>
            <ul class="mt-2">
              <li v-for="(opt,index) in curItem.implicitList" :key="index" :value="opt">{{opt}}</li>
            </ul>
          </b-container>
          <template v-slot:modal-footer="{ ok }" lang="html">
            <fragment>
              <b-button variant="primary" @click="ok()">OK</b-button>
            </fragment>
          </template>
        </b-modal>
      </b-card-text>
    </b-card>
    <importExportPack v-if="selectedModel" :model="selectedModel" :previewData="previewData" @refresh="getModelBasePackInfo"/>
  </section>
</template>

<script lang="js">
import importExportPack from '../../components/import_export_pack.vue';
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'pack_configurator',
  components: {importExportPack},
  methods: {
    openCloseRow(parentCode) {
      let parentIndex = -1
      let parent = null
      for (let i=0; i<this.packList.length;i++) {
        if (this.packList[i].ocparObj == parentCode) {
          parent = this.packList[i]
          parentIndex = i
          break
        }
      }
      let children = parent.listMasPackCommOpts
      if (this.showChildren.includes(parentCode)) {
        for (let i=0; i<children.length;i++) {
          children[i].isChild = false
          this.packList.splice(parentIndex+1,1)
        }
        this.showChildren.splice(this.showChildren.findIndex(el => el == parentCode),1)
      }
      else {
        for (let i=0; i<children.length;i++) {
          children[i].isChild = true
          this.packList.splice(parentIndex+1+i,0,children[i])
        }
        this.showChildren.push(parentCode)
      }
    },
    getModelBasePackInfo() {
      this.setSpinnerStatus(true);
      this.axios.get('/ccb/auth/fe/packConf/basePackInfo/'+this.selectedCountry.id+'/'+this.selectedModel.value+'/'+this.selectedModel.value2 ,  
        {params: { isPreview: this.previewData }, ...this.authHeader})
        .then((response) => {
          this.setSpinnerStatus(false);
          this.packList = response.data;
        });
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus'
    ])
  },
  data () {
    return {
      showChildren: [],
      currentPage:1,
      perPage:10,
      sortBy:'code',
      sortDesc: false,
      curItem:null,
      fields: [
         {
          key: 'plus',
          label: '',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'parentCode',
          label: 'Parent Code',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'childCode',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'inclExcl',
          label: 'Incl / Excl',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'optManovra',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'set',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'default',
          thClass: 'newLine',
          sortable: false
        },
        {
          key: 'implicitPacksContent',
          label: 'Implicit packs content',
          thClass: 'newLine',
          sortable: false
        }
      ],
      selectedCountry: (this.getCurUser) ? this.getCurUser.countries[0] : null,
      selectedModel: this.$store.state.selectedModel,
      previewData: false,
      packList:null,
    }
  },
  computed: {
    ...mapGetters([
      'getCurUser',
      'authHeader',
    ]) 
  },
  watch: {
    selectedCountry(newVal,oldVal){     
      if(newVal.modelGroupItemList && newVal.modelGroupItemList.length > 0 && newVal.modelGroupItemList[0].items.length > 0)
        this.selectedModel = newVal.modelGroupItemList[0].items[0];
      else 
        this.selectedModel = null;
    },
    selectedModel(newVal,oldVal){
      this.getModelBasePackInfo();
    },
    previewData(newVal, oldVal) {
      this.getModelBasePackInfo();
    },
  },
  mounted() {
    this.selectedCountry = (this.selectedCountry) ? this.selectedCountry : ((this.getCurUser && this.getCurUser.countries && this.getCurUser.countries.length) ? this.getCurUser.countries[0] : null) ;
    this.setCurApp('pack_conf');
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/_variables.scss';
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: .25rem;
}
</style>
